import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { CirculationId, Step } from "src/app/interfaces";

export const loadStepsForCirculation = createAction(
  "[Step/API] Load Steps for Circulation",
  props<{ id: CirculationId }>()
);

export const loadStepsForCirculationSuccess = createAction(
  "[Step/API] Load Steps for Circulation Success",
  props<{ steps: Step[] }>()
);

export const loadStepsForCirculationFailure = createAction(
  "[Step/API] Load Steps for Circulation Fail",
  props<{ error: HttpErrorResponse }>()
);
